import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { useParams } from 'react-router-dom';

const DatabaseModal = ({ isOpen, onClose, onSubmit, initialData }) => {
  const { projectId } = useParams();
  const [databaseData, setDatabaseData] = useState({
    databaseName: ''
  });

  useEffect(() => {
    if (initialData) {
      setDatabaseData({
        ...databaseData,
        databaseName: initialData?.databaseName,
      });
    }
  }, [initialData]);


  const handleSubmit = async (e) => {
    e.preventDefault();
    onSubmit(projectId, databaseData);
    onClose();
  };

  const handleCancel = () => {
    setDatabaseData({
      databaseName: '',
    });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm transition-opacity"></div>

      <div className="flex min-h-screen items-center justify-center p-4">
        <div className="relative w-full max-w-md transform overflow-hidden rounded-lg bg-white shadow-xl transition-all">
          {/* Header */}
          <div className="bg-gray-900 px-4 py-3 flex justify-between items-center">
            <h3 className="text-lg font-medium text-white">New Database Request</h3>
            <button
              onClick={handleCancel}
              className="rounded-full p-1 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none"
            >
              <X className="h-6 w-6" />
            </button>
          </div>

          {/* Content */}
          <div className="p-6">
            <form onSubmit={handleSubmit} className="space-y-4">
              {/* Database Name */}
              <div>
                <label className="text-gray-700 text-sm font-medium block mb-1">
                  Database Name
                </label>
                <input
                  type="text"
                  value={databaseData.databaseName}
                  onChange={(e) => setDatabaseData({ ...databaseData, databaseName: e.target.value })}
                  className="w-full px-3 py-2 border rounded-md focus:ring-1 focus:ring-indigo-500"
                  placeholder="Enter database name"
                  required
                />
              </div>

        

              {/* Buttons */}
              <div className="flex justify-end space-x-3 pt-4">
                <button
                  type="button"
                  onClick={handleCancel}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-700"
                >
                  Request Database
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DatabaseModal;